module.exports = {
    title: "Create Payment Calculator Setting",
    crud: {
        create: "Create Payment Calculator Setting",
        edit: "Edit Create Payment Calculator Setting",
        tableTitle:"History",
    },
    table: {
        title: "Title",
        isGstServiceProviderString: "Service Provider",
        isGstEndUserString: "End User",
        actions: "Actions",
        columns:{
            title:"title",
            isGstServiceProviderString: "isGstServiceProviderString",
            isGstEndUserString: "isGstEndUserString",
            actions:"actions",
        }
    },
    form: {
        title: "Title",
        scenarioNumber: "Scenario Number",
        isGstServiceProvider: "Is GST Service Provider",
        isGstEndUser: "Is GST End User",
        isPlatformCommission: "Is Platform Commission",
        platformCommission: "Platform Commission",
        isGstOnPlatformCommission: "Is GST On Platform Commission",
        gstOnPlatformCommission: "GST On Platform Commission",
        isPaymentGatewayCharges: "Is Payment Gateway Charges",
        paymentGatewayCharges: "Payment Gateway Charges",
        isGstOnPaymentGatewayCharges: "Is GST On Payment Gateway Charges",
        gstOnPaymentGatewayCharges: "GST On Payment Gateway Charges",
        isGstOnService: "Is GST On Service",
        gstOnService: "GST On Service",
        isGstOnSubscriptionFee: "Is GST On Subscription Fee",
        gstOnSubscriptionFee: "GST On Subscription Fee",
        isPrePayMode: "Is Pre Pay Mode",
        isGstOnPrePayMode: "Is GST On Pre Pay Mode",
        gstOnPrePayMode: "GST On Pre Pay Mode",
        isRefundToUsers: "Is Refund To Users",
        isGstOnRefundToUsers: "Is GST On Refund To Users",
        gstOnRefundToUsers: "GST On Refund To Users",
    },
    validation: {
        required: {
            title: 'Title is required'
        }
    },
}
